import createStore from 'framework/vuex/store';


/**
 * Initialize vuex
 */
function init(appRoot) {
    // Append a store to the root instance
    appRoot.store = createStore();
}

export default init;



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/vuex/index.js